import { render } from "./SidebarMenuSkeleton.vue?vue&type=template&id=87a81622&ts=true"
import script from "./SidebarMenuSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuSkeleton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarMenuSkeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87a81622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87a81622', __exports__)) {
    api.reload('87a81622', __exports__)
  }
  
  module.hot.accept("./SidebarMenuSkeleton.vue?vue&type=template&id=87a81622&ts=true", () => {
    api.rerender('87a81622', render)
  })

}


export default __exports__